<script lang="ts">
    import type {IUIElementTreeNode} from './ui-elements-list.types';
    import {elementSelectionStore} from '../../../stores/elementsSelection';
    import {guiCreatorDataStore} from '../../../stores/guiCreatorData';
    import Icon from 'svelte-icons-pack/Icon.svelte';
    import RiSystemErrorWarningLine from 'svelte-icons-pack/ri/RiSystemErrorWarningLine';
    import FaSolidLock from "svelte-icons-pack/fa/FaSolidLock";
    import FaSolidLockOpen from "svelte-icons-pack/fa/FaSolidLockOpen";
    import {decoupledGroupsStore} from '../../../stores/decoupledGroups';
    import ConfigTextInput from '../../../ui-elements/utils/ConfigTextInput.svelte';

    export let node: IUIElementTreeNode;
    export let level;
    const padding = 60 * parseInt(level) + 15;
    let decoupled = false;

    let groupNameValue = node.value;

    decoupledGroupsStore.subscribe((newDecoupledGroupsState) => {
        decoupled = newDecoupledGroupsState[node.value];
    })

    function onTreeNodeClick(treeNode: IUIElementTreeNode) {

        let startNode = node.leaf && node.uiElement.group ? node.parentNode : node;
        guiCreatorDataStore.setCurrentPage(treeNode.page);
        const allChildren = getAllChildrenUiElements(startNode, []);
        elementSelectionStore.set(allChildren);
    }

    function getAllChildrenUiElements(node: IUIElementTreeNode, children) {
        if (node.leaf) {
            children.push(node.uiElement);
        } else {
            node.children.forEach((childNode) => getAllChildrenUiElements(childNode, children));
        }
        return children;
    }

    function toggleDecoupleStatus() {
        const groupName = node.value;
        if (decoupledGroupsStore.isDecoupled(groupName)) {
            decoupledGroupsStore.coupleGroup(groupName)
        } else {
            decoupledGroupsStore.decoupleGroup(groupName)
        }
    }

    function onGroupNameChange(newName) {
        const oldGroupName = node.value;
        const uiElementWithSameGroup = guiCreatorDataStore.getAllElementsAsList().find(uiElement => uiElement.group === newName);
        if (uiElementWithSameGroup) {
            groupNameValue = node.value;
            return
        }
        const childNodes = node.children.filter((childNode) => childNode.uiElement).map((childNode) => {
            childNode.uiElement.group = newName;
            return childNode;
        });

        decoupledGroupsStore.updateGroupName(oldGroupName, newName);
        guiCreatorDataStore.updateMultiple(childNodes.map((childNode: IUIElementTreeNode) => childNode.uiElement), node.page);
    }

</script>

<div on:click|stopPropagation={() => onTreeNodeClick(node)} class="pb-1 border border-gray-200">
    {#if node.leaf}
        <div class="grid grid-flow-col auto-cols-max gap-x-1">

            <div class="element capitalize "
                 style="padding-left: {padding}px">{node.uiElement.uiElementType.toLowerCase()}: {node.value}</div>
            <div class="align-middle pt-1">
                {#if node.outsideOfScreen}
                    <div class="tooltip" data-tip="Element will not be visible on device screen">
                        <Icon src="{RiSystemErrorWarningLine}" color="#d1a402"></Icon>
                    </div>

                {/if}
            </div>
        </div>
    {:else }
        <div class="grid grid-flow-col auto-cols-max gap-x-1">
            <div class="element" style="padding-left: {padding}px; width: 150px">
                <ConfigTextInput active="{true}" value="{groupNameValue}" title="Group" on:configValueChanged="{(v) => onGroupNameChange(v.detail)}"></ConfigTextInput>
            </div>
            <button class="btn btn-xs btn-square btn-outline" on:click|stopPropagation={() => toggleDecoupleStatus()}>
                {#if decoupled}
                    <Icon src="{FaSolidLockOpen}"></Icon>
                {:else }
                    <Icon src="{FaSolidLock}"></Icon>
                {/if}
            </button>
        </div>
        {#each node.children as child}
            <div class="tree-row">
                <svelte:self node="{child}" level={parseInt(level)+1}></svelte:self>
            </div>

        {/each}
    {/if}
</div>
<style>
    .tree-row {
        width: 100%;
    }

    .element {
        width: 100%;
        text-align: left;
    }
</style>
